/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Pressable, Image } from 'react-native';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
  headerTitleStyle,
  headerLeftContainerStyle,
  headerBackTitleStyle,
  headerTitleContainerStyle,
} from '~assets/styles/headerStyles';
import { getCartProductCount } from '~store/cart/actions/cart';
const Placeholder = React.lazy(() => import('@web/plugins/placeholder'));
// screens
const HomeScreen = React.lazy(() => import('@web/screens/HomeScreen'));
const EditImageScreen = React.lazy(() =>
  import('@web/screens/EditImageScreen'),
);

const LoginControlScreen = React.lazy(() =>
  import('@web/screens/LoginControlScreen'),
);
const SignupScreen = React.lazy(() => import('@web/screens/SignupScreen'));
const QuickRegisterSignUpScreen = React.lazy(() =>
  import('@web/screens/QuickRegisterSignUpScreen'),
);

const SearchScreen = React.lazy(() => import('@web/screens/SearchScreen'));
const SearchResultScreen = React.lazy(() =>
  import('@web/screens/SearchResultScreen'),
);
const PromotionScreen = React.lazy(() =>
  import('@web/screens/PromotionScreen'),
);

const ShoppingBagScreen = React.lazy(() =>
  import('@web/screens/ShoppingBagScreen'),
);
const HelpScreen = React.lazy(() => import('@web/screens/help/HelpScreen'));
const HelpSearchResultScreen = React.lazy(() =>
  import('@web/screens/help/HelpSearchResultScreen'),
);
const TransactionProblemsScreen = React.lazy(() =>
  import('@web/screens/help/TransactionProblemsScreen'),
);
const TransactionDetailScreen = React.lazy(() =>
  import('@web/screens/help/TransactionDetailScreen'),
);
const ContactUsScreen = React.lazy(() =>
  import('@web/screens/help/ContactUsScreen'),
);
const AvailableVoucherScreen = React.lazy(() =>
  import('@web/screens/AvailableVoucherScreen'),
);
const VoucherRedeemScreen = React.lazy(() =>
  import('@web/screens/VoucherRedeemScreen'),
);
const CheckoutScreen = React.lazy(() => import('@web/screens/CheckoutScreen'));
const FormAddressScreen = React.lazy(() =>
  import('@web/screens/FormAddressScreen'),
);
const FormEditAddressScreen = React.lazy(() =>
  import('@web/screens/FormEditAddressScreen'),
);
const OtpVerificationControlScreen = React.lazy(() =>
  import('@web/screens/OtpVerificationControlScreen'),
);
const EmailVerification = React.lazy(() =>
  import('@web/screens/EmailVerification'),
);
// Payment
const DetailPayment = React.lazy(() =>
  import('@web/screens/payment/DetailPayment'),
);
const PaymentSuccess = React.lazy(() =>
  import('@web/screens/payment/PaymentSuccess'),
);
const PaymentWaiting = React.lazy(() =>
  import('@web/screens/payment/PaymentWaiting'),
);
const PaymentProcessing = React.lazy(() =>
  import('@web/screens/payment/PaymentProcessing'),
);
const PaymentFailed = React.lazy(() =>
  import('@web/screens/payment/PaymentFailed'),
);
const VospayWebView = React.lazy(() =>
  import('@web/screens/payment/webview/Vospay'),
);
const CimbClicksWebView = React.lazy(() =>
  import('@web/screens/payment/webview/CimbClicks'),
);
const GpnWebView = React.lazy(() => import('@web/screens/payment/webview/Gpn'));
const CreditCardWebView = React.lazy(() =>
  import('@web/screens/payment/webview/CreditCard'),
);
const KredivoWebView = React.lazy(() =>
  import('@web/screens/payment/webview/Kredivo'),
);
//
const ProfileScreen = React.lazy(() => import('@web/screens/ProfileScreen'));
const MyOrdersScreen = React.lazy(() => import('@web/screens/MyOrdersScreen'));
const WishlistScreen = React.lazy(() => import('@web/screens/WishlistScreen'));
const MyAddressScreen = React.lazy(() =>
  import('@web/screens/MyAddressScreen'),
);
const EditProfileScreen = React.lazy(() =>
  import('@web/screens/EditProfileScreen'),
);
const ExpectingMotherOnboardingScreen = React.lazy(() =>
  import('@web/screens/ExpectingMotherOnboardingScreen'),
);
const MotherWithKidsOnboardingScreen = React.lazy(() =>
  import('@web/screens/MotherWithKidsOnboardingScreen'),
);
const CompleteProfileScreen = React.lazy(() =>
  import('@web/screens/CompleteProfileScreen'),
);
const ContactUsInfoScreen = React.lazy(() =>
  import('@web/screens/ContactUs/ContactUsInfoScreen'),
);
const AffiliateWithUsScreen = React.lazy(() =>
  import('@web/screens/affiliate-with-us/AffiliateWithUsScreen'),
);

const ChangePasswordScreen = React.lazy(() =>
  import('@web/screens/ChangePasswordScreen'),
);
const ForgotPasswordScreen = React.lazy(() =>
  import('@web/screens/ForgotPasswordScreen'),
);

const QuickRegistrationScreen = React.lazy(() =>
  import('@web/screens/QuickRegistrationScreen'),
);

const QuickRegistrationVerifyScreen = React.lazy(() =>
  import('@web/screens/QuickRegistrationVerifyScreen'),
);

const ResetPasswordScreen = React.lazy(() =>
  import('@web/screens/ResetPasswordScreen'),
);
const SettingsScreen = React.lazy(() => import('@web/screens/SettingsScreen'));
const NewsletterScreen = React.lazy(() =>
  import('@web/screens/NewsletterScreen'),
);
const LanguageScreen = React.lazy(() => import('@web/screens/LanguageScreen'));
const InterestScreen = React.lazy(() => import('@web/screens/InterestScreen'));
const ShopByCategoriesScreen = React.lazy(() =>
  import('@web/screens/shop-by/ShopByCategoriesScreen'),
);
const ShopByBrandsScreen = React.lazy(() =>
  import('@web/screens/shop-by/ShopByBrandsScreen'),
);
const CategoryDetailScreen = React.lazy(() =>
  import('@web/screens/categories/CategoryDetailScreen'),
);

const PromoCategoryDetailScreen = React.lazy(() =>
  import('@web/screens/PromoCategoryDetailScreen'),
);

const BrandDetailScreen = React.lazy(() =>
  import('@web/screens/brands/BrandDetailScreen'),
);
const AboutBrandScreen = React.lazy(() =>
  import('@web/screens/brands/AboutBrandScreen'),
);
const ProductDetailScreen = React.lazy(() =>
  import('@web/screens/ProductDetailScreen'),
);
const AllReviewProductDetailScreen = React.lazy(() =>
  import('@web/screens/AllReviewProductDetailScreen'),
);
const FiltersByBrandScreen = React.lazy(() =>
  import('@web/screens/product-filters/FiltersByBrandScreen'),
);
const EGiftCardListScreen = React.lazy(() =>
  import('@web/screens/e-gift-card/EGiftCardListScreen'),
);
const EGiftPreviewScreen = React.lazy(() =>
  import('@web/screens/e-gift-card/EGiftPreviewScreen'),
);
const NewArrivalScreen = React.lazy(() =>
  import('@web/screens/new-arrival/NewArrivalScreen'),
);
const BestSellerScreen = React.lazy(() =>
  import('@web/screens/best-seller/BestSellerScreen'),
);
const PaymentConfirmationScreen = React.lazy(() =>
  import('@web/screens/PaymentConfirmationScreen'),
);
const PaymentConfirmationSuccessScreen = React.lazy(() =>
  import('@web/screens/PaymentConfirmationSuccessScreen'),
);
const OrderDetailScreen = React.lazy(() =>
  import('@web/screens/OrderDetailScreen'),
);
const HowToPayScreen = React.lazy(() => import('@web/screens/HowToPayScreen'));
const WebViewScreen = React.lazy(() => import('@web/screens/WebViewScreen'));
const UserProfileScreen = React.lazy(() =>
  import('@web/screens/UserProfileScreen'),
);
const CreateReviewScreen = React.lazy(() =>
  import('@web/screens/CreateReviewScreen'),
);

const CreateReviewScreenDesktop = React.lazy(() =>
  import('@web/screens/CreateReviewScreenDesktop'),
);
const EditReviewScreen = React.lazy(() =>
  import('@web/screens/EditReviewScreen'),
);
const EditReviewScreenDesktop = React.lazy(() =>
  import('@web/screens/EditReviewScreenDesktop'),
);
const MyReviewScreen = React.lazy(() => import('@web/screens/MyReviewScreen'));
const AddPhotoReviewScreen = React.lazy(() =>
  import('@web/screens/AddPhotoReviewScreen'),
);

const FlashSaleScreen = React.lazy(() =>
  import('@web/screens/FlashSaleScreen'),
);
const AboutUsScreen = React.lazy(() => import('@web/screens/AboutUsScreen'));
const CampaignScreen = React.lazy(() => import('@web/screens/CampaignScreen'));

//campaign v2
const CampaignV2Screen = React.lazy(() =>
  import('@web/screens/CampaignV2Screen'),
);

const CareersScreen = React.lazy(() => import('@web/screens/CareersScreen'));

const TermsAndConditionScreen = React.lazy(() =>
  import('@web/screens/terms-and-conditions/TermsAndConditionScreen'),
);
const PrivacyPolicyScreen = React.lazy(() =>
  import('@web/screens/privacy-policy/PrivacyPolicyScreen'),
);

// navigators
const CategoriesNavigator = React.lazy(() =>
  import('@web/navigation/CategoriesNavigator'),
);

// components
const HomeHeader = React.lazy(() =>
  import('@web-components/headers/HomeHeader'),
);

const HelpHeader = React.lazy(() =>
  import('@web-components/headers/HelpHeader'),
);
const PageHeader = React.lazy(() =>
  import('@web-components/headers/PageHeader'),
);
const FormAddressHeader = React.lazy(() =>
  import('@web-components/headers/FormAddressHeader'),
);
const SignupHeader = React.lazy(() =>
  import('@web-components/headers/SignupHeader'),
);
const SearchHeader = React.lazy(() =>
  import('@web-components/headers/SearchHeader'),
);
const RightHeader = React.lazy(() =>
  import('@web-components/headers/RightHeader'),
);
const RightHeaderAboutSocoPoints = React.lazy(() =>
  import('@web-components/headers/RightHeaderAboutSocoPoints'),
);
const LoginHeader = React.lazy(() =>
  import('@web-components/headers/LoginHeader'),
);
const ModalTrackOrder = React.lazy(() =>
  import('@web-components/modals/ModalTrackOrder'),
);
const ModalOrderRetry = React.lazy(() =>
  import('@web-components/modals/ModalOrderRetry'),
);
const ModalPackageReceived = React.lazy(() =>
  import('@web-components/modals/ModalPackageReceived'),
);
const ModalPackageReceivedSuccess = React.lazy(() =>
  import('@web-components/modals/ModalPackageReceivedSuccess'),
);
const ModalChangePhoneNumber = React.lazy(() =>
  import('@web-components/modals/ModalChangePhoneNumber'),
);
const ModalPhoneVerification = React.lazy(() =>
  import('@web-components/modals/ModalPhoneVerification'),
);

const ModalOrdersFilter = React.lazy(() =>
  import('@web-components/modals/ModalOrdersFilter'),
);
const ModalUserQR = React.lazy(() =>
  import('@web-components/modals/ModalUserQR'),
);

const StoreScreen = React.lazy(() => import('@web/screens/StoreScreen'));

const BabyRegistryScreen = React.lazy(() =>
  import('@web/screens/BabyRegistryScreen'),
);

const GiftingScreen = React.lazy(() =>
  import('@web/screens/gifting/GiftingScreen'),
);

const MembershipScreen = React.lazy(() =>
  import('@web/screens/MembershipScreen'),
);

const SocoPointsAboutScreen = React.lazy(() =>
  import('@web/screens/SocoPointsAboutScreen'),
);

const SocoPointsHistoryScreen = React.lazy(() =>
  import('@web/screens/SocoPointsHistoryScreen'),
);

const ParentVerificationEmailScreen = React.lazy(() =>
  import('@web/screens/ParentVerificationEmailScreen'),
);

const Atome = React.lazy(() => import('@web/screens/payment/detail/Atome'));
const OVO = React.lazy(() => import('@web/screens/payment/detail/Ovo'));
const CreditCard = React.lazy(() =>
  import('@web/screens/payment/detail/CreditCard'),
);
const ModalConfirmationCVV = React.lazy(() =>
  import('@web-components/payment/ModalConfirmationCVV'),
);
const ModalPinPoint = React.lazy(() =>
  import('@web-components/shipping/ModalPinPoint'),
);

import { storeAsyncData, getAsyncData } from '~global/helpers';
import * as authActions from '~store/user/actions/auth';
import { getBannersAll } from '~store/banners/thunks';
import { isWeb, isMobileWeb, isNative } from '~global/screens';

const Stack = createStackNavigator();
const key = '@storage_header';
const RootNavigator = ({ navigation, ...props }) => {
  const [showHeaderLogin, setShowHeaderLogin] = useState(false);
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();
  const { locations: statusBanners } = useSelector(
    (state) => state.banners.status,
  );

  useEffect(() => {
    const tryLogin = async () => {
      dispatch(authActions.getUserDetail()).then((response) => {
        if (response.isLoggedIn) {
          dispatch(getCartProductCount());
        }

        if (response && !response.isLoggedIn) {
          dispatch({
            type: 'babyRegistry/setIsAllowedAccessToRegistry',
            data: false,
          });
        }
      });
    };
    tryLogin();
  }, [dispatch]);

  useEffect(() => {
    if (statusBanners == 'idle') {
      dispatch(
        getBannersAll({
          filter: {
            locations: [
              'home',
              'just_landed_in_lulla_text',
              'lulla_exclusive',
              'lulla_exclusive_text',
              'popup_banner',
              'regular_flashsale_theme',
              'searchbar_promo_text',
              'top_banners',
              'partner_bank_promotion',
              'home_gift',
              'gift_page',
            ],
          },
        }),
      );
    }
  }, [dispatch, statusBanners]);

  useEffect(() => {
    getAsyncData(key).then((value) => {
      if (value) {
        setShowHeaderLogin(false);
      } else {
        setShowHeaderLogin(true);
      }
    });
  }, [showHeaderLogin]);

  return (
    <Suspense fallback={<Placeholder />}>
      <Stack.Navigator
        screenOptions={{
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          headerStyle: {
            height: 55 + insets.top,
          },
          cardStyle: {
            flex: 1,
          },
          headerStatusBarHeight: insets.top,
          headerTitleStyle,
          headerTitleAlign: 'left',
          headerTitleContainerStyle,
          headerLeftContainerStyle,
          headerBackTitleStyle,
          headerLeft: (props) => (
            <Pressable {...props} style={{ paddingLeft: 16 }}>
              <Image
                style={{ height: 20, width: 20 }}
                source={require('~assets/img/common/arrow-back.png')}
              />
            </Pressable>
          ),
          animationEnabled: false,
        }}>
        <Stack.Screen
          name="HomeScreen"
          component={HomeScreen}
          options={{
            ...{
              header: (props) => (!isWeb ? <HomeHeader {...props} /> : null),
            },
          }}
        />
        <Stack.Screen
          name="SearchScreen"
          component={SearchScreen}
          options={{ header: (props) => <SearchHeader {...props} /> }}
        />
        <Stack.Screen
          name="SearchResultScreen"
          component={SearchResultScreen}
          options={{
            title: 'Search Result',
            ...(isWeb && { header: (props) => <></> }),
          }}
        />
        <Stack.Screen
          name="ShoppingBagScreen"
          component={ShoppingBagScreen}
          options={{
            title: 'Shopping Bag',
            ...(isWeb && { header: (props) => <></> }),
          }}
        />
        <Stack.Screen
          name="HelpScreen"
          component={HelpScreen}
          options={{
            title: 'Help Center',
            ...(isWeb && { header: (props) => <HelpHeader {...props} /> }),
          }}
        />
        <Stack.Screen
          name="HelpSearchResultScreen"
          component={HelpSearchResultScreen}
          options={{
            title: 'Help Search Result',
            header: (props) => <HelpHeader {...props} />,
          }}
        />
        <Stack.Screen
          name="TransactionProblemsScreen"
          component={TransactionProblemsScreen}
          options={{ title: 'Transaction Issues' }}
        />
        <Stack.Screen
          name="TransactionDetailScreen"
          component={TransactionDetailScreen}
          options={{ title: 'Detail Transaction Issues' }}
        />
        <Stack.Screen
          name="ContactUsScreen"
          component={ContactUsScreen}
          options={{
            title: 'Contact Us',
            header: (props) => <HelpHeader {...props} />,
          }}
        />
        <Stack.Screen
          name="CategoriesNavigator"
          component={CategoriesNavigator}
          options={{
            title: 'Categories',
            header: (props) => <HelpHeader {...props} />,
          }}
        />
        <Stack.Screen
          name="PromotionScreen"
          component={PromotionScreen}
          options={{
            title: 'Promotion',
            ...(isWeb && { header: (props) => <></> }),
          }}
        />

        <Stack.Screen
          name="AvailableVoucherScreen"
          component={AvailableVoucherScreen}
          options={{ title: `Available Vouchers` }}
        />

        <Stack.Screen
          name="VoucherRedeemScreen"
          component={VoucherRedeemScreen}
          options={{
            title: `Voucher & SOCO Points`,
            headerTitleStyle: {
              fontSize: 16,
              lineHeight: 24,
              fontFamily: 'satoshi-bold',
            },
          }}
        />

        <Stack.Screen
          name="CheckoutScreen"
          component={CheckoutScreen}
          options={{
            title: 'Checkout',
            ...(isWeb && { header: (props) => <></> }),
          }}
        />
        <Stack.Screen
          name="FormAddressScreen"
          component={FormAddressScreen}
          options={{
            title: 'Add New Address',
            ...(isWeb && {
              header: (props) => <FormAddressHeader {...props} />,
            }),
          }}
        />

        <Stack.Screen
          name="FormEditAddressScreen"
          component={FormEditAddressScreen}
          options={{
            title: 'Edit Shipping Address',
            ...(isWeb && {
              header: (props) => <FormAddressHeader {...props} />,
            }),
          }}
        />

        <Stack.Screen
          name="LoginControlScreen"
          component={LoginControlScreen}
          options={({ route: { params } }) => {
            return {
              title: params.title || 'Login',
              ...(isMobileWeb &&
                showHeaderLogin && {
                  header: (props) => (
                    <LoginHeader
                      onClose={() => {
                        storeAsyncData(key, true);
                        setShowHeaderLogin(false);
                      }}
                    />
                  ),
                }),
            };
          }}
        />
        <Stack.Screen
          name="SignupScreen"
          component={SignupScreen}
          options={{
            title: 'Register',
            ...(isWeb && { header: (props) => <SignupHeader {...props} /> }),
          }}
        />

        <Stack.Screen
          name="QuickRegisterSignUpScreen"
          component={QuickRegisterSignUpScreen}
          options={{
            title: 'Quick Register',
            ...(isWeb && { header: (props) => <SignupHeader {...props} /> }),
          }}
        />
        <Stack.Screen
          name="InterestScreen"
          component={InterestScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              if (props?.route?.params?.tab) {
                newProps.header = (props2) => <HomeHeader {...props2} />;
              } else {
                newProps.header = (props2) => <SignupHeader {...props2} />;
              }
            }
            newProps.title = props?.params?.title || 'My Interest';
            return newProps;
          }}
        />
        <Stack.Screen
          name="DetailPayment"
          component={DetailPayment}
          options={{
            title: 'Detail Payment',
          }}
        />
        <Stack.Screen
          name="PaymentWaiting"
          component={PaymentWaiting}
          options={{
            title: 'Waiting For Payment',
            gestureEnabled: false,
            ...(isWeb && { header: (props) => <></> }),
          }}
        />
        <Stack.Screen
          name="PaymentProcessing"
          component={PaymentProcessing}
          options={{
            headerShown: isWeb ? true : false,
            title: 'Waiting For Payment',
            gestureEnabled: false,
            ...(isWeb && { header: (props) => <HomeHeader {...props} /> }),
          }}
        />
        <Stack.Screen
          name="PaymentFailed"
          component={PaymentFailed}
          options={{
            title: 'Kartu Kredit / Debit Online',
            gestureEnabled: false,
            ...(isWeb && { header: (props) => <HomeHeader {...props} /> }),
          }}
        />
        <Stack.Screen
          name="OtpVerificationControlScreen"
          component={OtpVerificationControlScreen}
          options={{
            title: isNative ? 'Verification' : 'Verification',
            ...(isWeb && { header: (props) => <SignupHeader {...props} /> }),
          }}
        />
        <Stack.Screen
          name="user"
          component={UserProfileScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            newProps.title = props?.params?.title;
            return newProps;
          }}
        />

        <Stack.Screen
          name="EmailVerification"
          component={EmailVerification}
          options={{
            title: 'Verification',
            ...(isWeb && { header: (props) => <SignupHeader {...props} /> }),
          }}
        />
        <Stack.Screen
          name="EditProfileScreen"
          component={EditProfileScreen}
          options={({ route: { params } }) => ({
            title: params?.title || 'Edit Profile',
          })}
        />
        <Stack.Screen
          name="ExpectingMotherOnboardingScreen"
          component={ExpectingMotherOnboardingScreen}
          options={{ title: 'Megandung' }}
        />
        <Stack.Screen
          name="MotherWithKidsOnboardingScreen"
          component={MotherWithKidsOnboardingScreen}
          options={{ title: 'Ibu dan Anak' }}
        />
        <Stack.Screen
          name="ContactUsInfoScreen"
          component={ContactUsInfoScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            newProps.title = 'Contact Us';
            return newProps;
          }}
        />
        <Stack.Screen
          name="AffiliateWithUsScreen"
          component={AffiliateWithUsScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            newProps.title = 'Business Partner';
            return newProps;
          }}
        />
        <Stack.Screen
          name="CompleteProfileScreen"
          component={CompleteProfileScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <SignupHeader {...props2} />;
            }
            newProps.title = isMobileWeb
              ? 'Complete Your Profile'
              : 'Complete Data';
            return newProps;
          }}
        />
        <Stack.Screen
          name="ChangePasswordScreen"
          component={ChangePasswordScreen}
          options={{ title: 'Change Password' }}
        />
        <Stack.Screen
          name="ForgotPasswordScreen"
          component={ForgotPasswordScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <SignupHeader {...props2} />;
            }
            newProps.title = 'Forgot Password';
            return newProps;
          }}
        />

        <Stack.Screen
          name="QuickRegistrationScreen"
          component={QuickRegistrationScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <SignupHeader {...props2} />;
            }
            newProps.title = isWeb ? 'Register' : null;
            return newProps;
          }}
        />

        <Stack.Screen
          name="QuickRegistrationVerifyScreen"
          component={QuickRegistrationVerifyScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <SignupHeader {...props2} />;
            }
            newProps.title = isWeb ? 'Verify' : null;
            return newProps;
          }}
        />

        <Stack.Screen
          name="ResetPasswordScreen"
          component={ResetPasswordScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <SignupHeader {...props2} />;
            }
            newProps.title = 'Reset Password';
            return newProps;
          }}
        />
        <Stack.Screen
          name="ProfileScreen"
          component={ProfileScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            newProps.title = isNative
              ? 'Profile'
              : props?.params?.title || 'My Profile';
            return newProps;
          }}
        />
        <Stack.Screen
          name="MyOrdersScreen"
          component={MyOrdersScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            if (isMobileWeb && !props.navigation.canGoBack()) {
              newProps.headerLeft = (props2) => (
                <Pressable
                  {...props2}
                  style={{ paddingLeft: 16 }}
                  onPress={() => props.navigation.navigate('ProfileScreen')}>
                  <Image
                    style={{ height: 20, width: 20 }}
                    source={require('~assets/img/common/arrow-back.png')}
                  />
                </Pressable>
              );
            }
            newProps.title = props?.params?.title || 'My Orders';
            return newProps;
          }}
        />
        <Stack.Screen
          name="WishlistScreen"
          component={WishlistScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            if (isMobileWeb && !props.navigation.canGoBack()) {
              newProps.headerLeft = (props2) => (
                <Pressable
                  {...props2}
                  style={{ paddingLeft: 16 }}
                  onPress={() => props.navigation.navigate('ProfileScreen')}>
                  <Image
                    style={{ height: 20, width: 20 }}
                    source={require('~assets/img/common/arrow-back.png')}
                  />
                </Pressable>
              );
            }
            newProps.title = props?.params?.title || 'Wishlist';
            return newProps;
          }}
        />
        <Stack.Screen
          name="MyAddressScreen"
          component={MyAddressScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            if (isMobileWeb && !props.navigation.canGoBack()) {
              newProps.headerLeft = (props2) => (
                <Pressable
                  {...props2}
                  style={{ paddingLeft: 16 }}
                  onPress={() => props.navigation.navigate('ProfileScreen')}>
                  <Image
                    style={{ height: 20, width: 20 }}
                    source={require('~assets/img/common/arrow-back.png')}
                  />
                </Pressable>
              );
            }
            newProps.title = isNative ? 'My Address' : 'Shipping Address';
            return newProps;
          }}
        />
        <Stack.Screen
          name="VospayWebView"
          component={VospayWebView}
          options={{ title: 'VOSPAY' }}
        />
        <Stack.Screen
          name="CimbClicksWebView"
          component={CimbClicksWebView}
          options={{ title: 'OCTO CLICKS' }}
        />
        <Stack.Screen
          name="GpnWebView"
          component={GpnWebView}
          options={{ title: 'KARTU DEBIT GPN' }}
        />
        <Stack.Screen
          name="SettingsScreen"
          component={SettingsScreen}
          options={{ title: 'Settings' }}
        />
        <Stack.Screen
          name="CreditCardWebView"
          component={CreditCardWebView}
          options={{ title: 'KARTU KREDIT / DEBIT' }}
        />
        <Stack.Screen
          name="KredivoWebView"
          component={KredivoWebView}
          options={{ title: 'Kredivo' }}
        />
        <Stack.Screen
          name="NewsletterScreen"
          component={NewsletterScreen}
          options={{ title: 'Newsletter' }}
        />
        <Stack.Screen
          name="LanguageScreen"
          component={LanguageScreen}
          options={{ title: 'Language' }}
        />
        <Stack.Screen
          name="PaymentSuccess"
          component={PaymentSuccess}
          options={{
            header: (props) => <></>,
          }}
        />
        <Stack.Screen
          name="TermsAndConditionScreen"
          component={TermsAndConditionScreen}
          options={{
            title: 'Terms And Conditions',
            gestureEnabled: false,
            ...(isWeb && { header: (props) => <PageHeader {...props} /> }),
          }}
        />
        <Stack.Screen
          name="PrivacyPolicyScreen"
          component={PrivacyPolicyScreen}
          options={{
            title: 'Privacy Policy',
            gestureEnabled: false,
            ...(isWeb && { header: (props) => <PageHeader {...props} /> }),
          }}
        />
        <Stack.Screen
          name="ShopByCategoriesScreen"
          component={ShopByCategoriesScreen}
          options={{
            title: 'Shop by Categories',
            headerTitleStyle: {
              color: '#404040',
              fontFamily: 'satoshi-bold',
              fontSize: 16,
              lineHeight: 20,
            },
          }}
        />
        <Stack.Screen
          name="ShopByBrandsScreen"
          component={ShopByBrandsScreen}
          options={{
            title: 'Shop by Brands',
            headerTitleStyle: {
              color: '#404040',
              fontFamily: 'satoshi-bold',
              fontSize: 16,
              lineHeight: 20,
            },
          }}
        />
        <Stack.Screen
          name="PromoCategoryDetailScreen"
          component={PromoCategoryDetailScreen}
          options={{
            ...(isWeb && { header: (props) => <></> }),
          }}
        />
        <Stack.Screen
          name="CategoryDetailScreen"
          component={CategoryDetailScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            newProps.title = props?.params?.title || '';
            return newProps;
          }}
        />

        <Stack.Screen
          name="BrandDetailScreen"
          component={BrandDetailScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            if (isMobileWeb && !props.navigation.canGoBack()) {
              newProps.headerLeft = (props2) => (
                <Pressable
                  {...props2}
                  style={{ paddingLeft: 16 }}
                  onPress={() => navigation.navigate('HomeScreen')}>
                  <Image
                    style={{ height: 20, width: 20 }}
                    source={require('~assets/img/common/arrow-back.png')}
                  />
                </Pressable>
              );
            }
            return newProps;
          }}
        />
        <Stack.Screen
          name="NewArrivalScreen"
          component={NewArrivalScreen}
          options={{
            title: 'New Arrival',
            ...(isWeb
              ? {
                  header: (props) => null,
                }
              : {
                  headerRight: (props) => (
                    <RightHeader
                      {...props}
                      notShowingUser
                      notShowingCartCount
                      showSearch
                      showAdditionalMenu
                    />
                  ),
                }),
          }}
        />
        <Stack.Screen
          name="EGiftCardListScreen"
          component={EGiftCardListScreen}
          options={{
            title: 'e-Gift Card',
            headerStyle: {
              borderBottomWidth: 0,
            },
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  headerRight: (props) => (
                    <RightHeader
                      {...props}
                      notShowingUser
                      notShowingCartCount
                      showSearch
                      showAdditionalMenu
                    />
                  ),
                }),
          }}
        />
        <Stack.Screen
          name="EGiftPreviewScreen"
          component={EGiftPreviewScreen}
          options={{
            title: 'Preview',
            headerRight: (props) => (
              <RightHeader {...props} notShowingUser notShowingCartCount />
            ),
          }}
        />

        <Stack.Screen
          name="BestSellerScreen"
          component={BestSellerScreen}
          options={{
            title: 'Best Seller',
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  headerRight: (props) => (
                    <RightHeader {...props} showSearch showAdditionalMenu />
                  ),
                }),
          }}
        />
        <Stack.Screen
          name="ProductDetailScreen"
          component={ProductDetailScreen}
          options={{
            title: 'Product Detail',
            headerRight: (props) => (
              <RightHeader
                {...props}
                notShowingUser
                showShoppingBag
                showAdditionalMenu
              />
            ),
          }}
        />
        <Stack.Screen
          name="AllReviewProductDetailScreen"
          component={AllReviewProductDetailScreen}
          options={{
            title: 'All Reviews',
          }}
        />
        <Stack.Screen
          name="FiltersByBrandScreen"
          component={FiltersByBrandScreen}
          options={{
            title: 'Filter by Brand',
          }}
        />
        <Stack.Screen
          name="AboutBrandScreen"
          component={AboutBrandScreen}
          options={{
            title: 'About Brand',
          }}
        />
        <Stack.Screen
          name="EditImageScreen"
          component={EditImageScreen}
          options={{ title: 'Set Photo' }}
        />
        <Stack.Screen
          name="CreateReviewScreen"
          component={CreateReviewScreen}
          options={{
            title: 'Select Product',
            gestureEnabled: false,
          }}
        />
        <Stack.Screen
          name="CreateReviewScreenDesktop"
          component={CreateReviewScreenDesktop}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }

            if (isMobileWeb && !props.route.params?.data?.previous_screen) {
              newProps.headerLeft = (props2) => (
                <Pressable
                  {...props2}
                  style={{ paddingLeft: 16 }}
                  onPress={() => navigation.navigate('HomeScreen')}>
                  <Image
                    style={{ height: 20, width: 20 }}
                    source={require('~assets/img/common/arrow-back.png')}
                  />
                </Pressable>
              );
            }
            newProps.title = 'Review';
            return newProps;
          }}
        />
        <Stack.Screen
          name="EditReviewScreen"
          component={EditReviewScreen}
          options={{
            title: 'Edit Rating',
            gestureEnabled: false,
          }}
        />
        <Stack.Screen
          name="EditReviewScreenDesktop"
          component={EditReviewScreenDesktop}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            newProps.title = 'Review';
            return newProps;
          }}
        />
        <Stack.Screen
          name="MyReviewScreen"
          component={MyReviewScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            newProps.title = 'Review Saya';
            newProps.gestureEnabled = false;
            return newProps;
          }}
        />
        <Stack.Screen
          name="AddPhotoReviewScreen"
          component={AddPhotoReviewScreen}
          options={{
            title: 'Add Photo',
            gestureEnabled: false,
          }}
        />
        <Stack.Screen
          name="PaymentConfirmationScreen"
          component={PaymentConfirmationScreen}
          options={{
            title: 'Payment Confirmation',
            ...(isWeb && { header: (props) => <></> }),
          }}
        />
        <Stack.Screen
          name="PaymentConfirmationSuccessScreen"
          component={PaymentConfirmationSuccessScreen}
          options={{
            header: (props) => <></>,
          }}
        />
        <Stack.Screen
          name="OrderDetailScreen"
          component={OrderDetailScreen}
          options={(props) => {
            const newProps = { ...props };
            if (isWeb) {
              newProps.header = (props2) => <></>;
            }
            if (isMobileWeb && !props.route.params?.data?.previous_screen) {
              newProps.headerLeft = (props2) => (
                <Pressable
                  {...props2}
                  style={{ paddingLeft: 16 }}
                  onPress={() => navigation.navigate('MyOrderWebScreen')}>
                  <Image
                    style={{ height: 20, width: 20 }}
                    source={require('~assets/img/common/arrow-back.png')}
                  />
                </Pressable>
              );
            }
            newProps.title = 'Order Detail';
            return newProps;
          }}
        />
        <Stack.Screen
          name="WebViewScreen"
          component={WebViewScreen}
          options={{ title: 'Page' }}
        />
        <Stack.Screen
          name="HowToPayScreen"
          component={HowToPayScreen}
          options={{
            title: 'How to Pay',
            gestureEnabled: false,
            ...(isWeb && { header: (props) => <></> }),
          }}
        />
        <Stack.Screen
          name="AboutUsScreen"
          component={AboutUsScreen}
          options={{
            title: 'About Us',
            ...(isWeb && { header: (props) => <></> }),
          }}
        />
        <Stack.Screen
          name="CampaignScreen"
          component={CampaignScreen}
          options={{
            title: '...',
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  headerRight: (props) => (
                    <RightHeader
                      {...props}
                      showSearch
                      showShoppingBag
                      showAdditionalMenu
                    />
                  ),
                }),
          }}
        />
        <Stack.Screen
          name="CampaignV2Screen"
          component={CampaignV2Screen}
          options={{
            title: '...',
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  headerRight: (props) => (
                    <RightHeader
                      {...props}
                      showSearch
                      showShoppingBag
                      showAdditionalMenu
                    />
                  ),
                }),
          }}
        />

        <Stack.Screen
          name="CampaignV2TypeGiftScreen"
          component={CampaignV2Screen}
          options={{
            title: '...',
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  headerRight: (props) => (
                    <RightHeader
                      {...props}
                      showSearch
                      showShoppingBag
                      showAdditionalMenu
                    />
                  ),
                }),
          }}
        />

        <Stack.Screen
          name="CampaignV2TypeCategoryPhaseScreen"
          component={CampaignV2Screen}
          options={{
            title: '...',
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  headerRight: (props) => (
                    <RightHeader
                      {...props}
                      showSearch
                      showShoppingBag
                      showAdditionalMenu
                    />
                  ),
                }),
          }}
        />

        <Stack.Screen
          name="BabyRegistryScreen"
          component={BabyRegistryScreen}
          options={{
            title: 'Baby Registry',
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  title: props?.params?.title || '',
                }),
          }}
        />

        <Stack.Screen
          name="StoreScreen"
          component={StoreScreen}
          options={{
            title: 'Our Store',
            ...(isWeb && {
              header: (props) => <></>,
            }),
          }}
        />

        <Stack.Screen
          name="CareersScreen"
          component={CareersScreen}
          options={{
            title: 'Careers',
            ...(isWeb && { header: (props) => <PageHeader {...props} /> }),
          }}
        />

        <Stack.Screen
          name="FlashSaleScreen"
          component={FlashSaleScreen}
          options={{
            title: 'Flash Sale',
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  headerRight: (props) => (
                    <RightHeader
                      {...props}
                      showSearch={true}
                      showShoppingBag={true}
                      showAdditionalMenu={true}
                    />
                  ),
                }),
          }}
        />

        <Stack.Screen
          name="GiftingScreen"
          component={GiftingScreen}
          options={{
            title: 'Gift',
            headerTitleStyle: {
              top: 4,
              position: 'relative',
            },
            headerStyle: {
              borderBottomWidth: 0,
            },
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  headerRight: (props) => (
                    <RightHeader
                      {...props}
                      notShowingUser
                      showShoppingBag
                      showAdditionalMenu
                    />
                  ),
                }),
          }}
        />

        <Stack.Screen
          name="MembershipScreen"
          component={MembershipScreen}
          options={{
            title: 'Membership',
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  headerRight: (props) => (
                    <RightHeader
                      {...props}
                      notShowingUser
                      showShoppingBag
                      showAdditionalMenu
                    />
                  ),
                }),
          }}
        />

        <Stack.Screen
          name="SocoPointsAboutScreen"
          component={SocoPointsAboutScreen}
          options={{
            title: 'About Soco Point',
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  headerRight: (props) => (
                    <RightHeaderAboutSocoPoints {...props} />
                  ),
                }),
          }}
        />

        <Stack.Screen
          name="SocoPointsHistoryScreen"
          component={SocoPointsHistoryScreen}
          options={{
            title: 'Soco Point History',
            ...(isWeb
              ? {
                  header: (props) => <></>,
                }
              : {
                  headerRight: (props) => (
                    <RightHeader
                      {...props}
                      notShowingUser
                      showShoppingBag
                      showAdditionalMenu
                    />
                  ),
                }),
          }}
        />

        <Stack.Screen
          name="ParentVerificationEmailScreen"
          component={ParentVerificationEmailScreen}
          options={{ title: 'Verifikasi Email Orang Tua / Wali' }}
        />

        <Stack.Screen
          name="CreditCardScreen"
          component={CreditCard}
          options={{
            title: 'Credit / Debit Card',
            headerStyle: { shadowColor: 'transparent', elevation: 0 },
          }}
        />

        <Stack.Screen
          name="OvoScreen"
          component={OVO}
          options={{
            title: 'Input Phone Number',
            headerStyle: {
              borderBottomWidth: 0,
              shadowColor: 'transparent',
              elevation: 0,
            },
          }}
        />

        <Stack.Screen
          name="AtomeScreen"
          component={Atome}
          options={{
            title: 'Input Phone Number',
            headerStyle: {
              borderBottomWidth: 0,
              shadowColor: 'transparent',
              elevation: 0,
            },
          }}
        />
      </Stack.Navigator>

      <ModalOrderRetry />
      <ModalOrdersFilter />
      <ModalUserQR />
      <ModalPackageReceived />
      <ModalPackageReceivedSuccess />
      <ModalChangePhoneNumber
        navigation={navigation}
        authActions={authActions}
      />
      <ModalPhoneVerification navigation={navigation} />
      <ModalTrackOrder />
      <ModalConfirmationCVV navigation={navigation} />
      <ModalPinPoint />
    </Suspense>
  );
};

export default RootNavigator;
